import { useMutation } from "react-query";
import servicesUtils from "../../../../utils/servicesUtils";

const useCallOrchestrator = (workspaceId, conversationId) => {
  let url = `/llm_orchestrator/workspaces/${workspaceId}/conversations/${conversationId}/orchestrate/`;
  return useMutation((params) =>
    servicesUtils.postService(url, {
      ...params,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
  );
};

export default useCallOrchestrator;
